import { render } from "./UserPushTokensPage.vue?vue&type=template&id=12bd795b&scoped=true"
import script from "./UserPushTokensPage.vue?vue&type=script&lang=js"
export * from "./UserPushTokensPage.vue?vue&type=script&lang=js"

import "./UserPushTokensPage.vue?vue&type=style&index=0&id=12bd795b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12bd795b"]])

export default __exports__